import handlecart from "./handlecart";
import {combineReducers} from "redux";

const RootReducers= combineReducers({
    handlecart,
})

export default RootReducers;